import { STATE_ICONS } from "@/components/ui/concept-icons";
import { Button } from "@/components/ui";
import { MarkdownContent } from "@/components/ui/markdown-content";
import { useT } from "@/i18n";
import { framesConversationMessages } from "@/i18n/messages/frames-conversation";
import { openTaskDetails } from "@/lib/right-panel-navigation";
import { stripNativeResultPrefix } from "@/lib/work-toast-result-summary";

export function ConversationNativeResultNotice({
  id,
  title,
  taskId,
  content,
  testId = "conversation-frame",
}: {
  id: string;
  title: string;
  taskId: string | null;
  content: string;
  testId?: string;
}) {
  const t = useT(framesConversationMessages);
  const noticeTestId = `${testId}-native-result-${id}`;
  return (
    <div
      className="my-2 rounded-control border border-glass-stroke-faint bg-glass-fill px-3 py-2"
      data-testid={noticeTestId}
    >
      <div className="flex items-center gap-2">
        <STATE_ICONS.done className="h-3.5 w-3.5 shrink-0 text-accent" />
        <span className="min-w-0 flex-1 truncate text-canvas-xs font-semibold text-primary">
          {title}
        </span>
        {taskId && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => void openTaskDetails(taskId)}
            data-testid={`${noticeTestId}-open-task`}
          >
            {t("openTask")}
          </Button>
        )}
      </div>
      <MarkdownContent
        content={stripNativeResultPrefix(content)}
        className="mt-1 line-clamp-6 text-canvas-xs text-secondary [&_p]:leading-snug"
      />
    </div>
  );
}
